import * as React from 'react';
import { Link, MemoryRouter, StaticRouter } from 'react-router';
import Linkmuimateriallink from '@mui/material/Link';
import Box from '@mui/material/Box';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "react-router": { Link, MemoryRouter, StaticRouter }, "@mui/material/Link": Linkmuimateriallink, "@mui/material/Box": Box } } });
export default ClientProvider;
